import { ListCard, ListCardRow, Spinner, Body } from "@athena/ui";
import { useTranslation } from "react-i18next";
import { PresenterModal } from "@/components/PresenterModal";
import type { PresentersQuery } from "@/graphql/presenters.generated";
import type { ErrorLike } from "@apollo/client";

interface CoursePresentersTableProps {
    presenters: PresentersQuery["presenters"] | null;
    presentersLoading: boolean;
    presentersError: ErrorLike | undefined;
    selectedPresenterIds: Set<string>;
    togglePresenter: (itemId: string) => void;
}

export function CoursePresentersTable({
    presenters,
    presentersLoading,
    presentersError,
    selectedPresenterIds: selectedPresenters,
    togglePresenter,
}: CoursePresentersTableProps) {
    const { t } = useTranslation();

    if (!presenters) return;

    return (
        <ListCard title={t("common.fields.presenters")} description={t("admin.lms.presenterHelper")}>
            <ListCardRow className="flex flex-col items-start gap-3">
                {presentersLoading ? (
                    <Spinner />
                ) : (
                    <PresenterModal
                        allPresenters={presenters}
                        selectedPresenterIds={selectedPresenters}
                        onToggle={togglePresenter}
                    />
                )}
                {presentersError && <Body>Unable to load presenters at this time.</Body>}
            </ListCardRow>
        </ListCard>
    );
}
